import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa'; // Import WhatsApp icon from react-icons
import './PaymentPage.css'; // Custom styles

const PaymentPage = () => {
  return (
    <div className="payment-page">
      <div className="content-wrapper">
        <h2 className="highlighted-text">For Booking </h2>
        <h3>Click on the below whatsapp icon  </h3>
        <a href="https://wa.me/+919740579800" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
          <FaWhatsapp size={85} />
        </a>
        <h2> or</h2>
        <p className="highlighted-text">
          Call us at <strong><b className="phone-number">9740579800</b></strong> for further assistance.
        </p>
        
        {/* Go to Home link with WhatsApp Icon */}
        <div className="home-link-container">
          <Link to="/" className="home-link">
            Go to Home
          </Link>
          {/* <a href="https://wa.me/+919740579800" target="_blank" rel="noopener noreferrer" className="whatsapp-link home-whatsapp-icon">
            <FaWhatsapp size={20} />
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
